import {RMDNotificationResponse} from "@/services/types/RMDNotificationResponse";

export class RMDNotificationStore {
  cache: RMDNotificationResponse = {message_DE: '', message_PL: '', message_CZ: '', from: null, to: null};

  getNotification(lang: string) {
    if (!this.cache) {
      return null;
    }
    const message = this.cache['message_' + lang.toUpperCase() as keyof RMDNotificationResponse];
    const now = new Date();
    const fromStr = this.cache['from' as keyof RMDNotificationResponse];
    const toStr = this.cache['to' as keyof RMDNotificationResponse];
    if (fromStr) {
      const from = new Date(fromStr);
      if (now < from) {
        return null;
      }
    }
    if (toStr) {
      const to = new Date(toStr);
      if (now > to) {
        return null;
      }
    }
    if (!message) {
      return null;
    }

    return message;
  }
}
